import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  padding-top: ${({ theme }) => theme.spacing[2]}px;
  gap: ${({ theme }) => theme.spacing[4]}px;
`;

export const Coluna = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[4]}px;

  padding: 0 ${({ theme }) => theme.spacing[4]}px;
`;
